<template>
  <div class="schedule">
    <Title :title="title" :description="description"></Title>
    <!-- {{dayList}} {{scheduleList}} -->
    <p v-if="dayList.length==0" class="no-schedule">敬请期待</p>
    <div class="content-wrapper" v-else>
        <!-- 页角导航 -->
        <div id="menu" class="pc" style="display: none;">
          <ul>
            <li v-for="(item,index) in dayList" :key="'menu_li_'+index">
              <a @click.prevent="toggleDay(index, $event)" 
                :class="selectedDate==item.timeStamp?'dianji current':'dianji'"
                :data-time="item.timeStamp"
              >
                DAY{{index+1}}
              </a>
            </li>
          </ul>
        </div>
      <!-- pc -->
      <section class="schedule-content" :style="`--td-width-re:${setTdWidth(scheduleLen)}px;`">
        <!-- 导航  -->
        <div class="schedule-time">
          <div
            class="time-item"
            v-for="(item, index) in dayList"
            :key="index"
            :data-time="item.timeStamp"
            :class="item.timeStamp === selectedDate ? 'selected' : ''"
            @click="toggleDay(index, $event)"
          >
            <h4>DAY{{ index + 1 }}</h4>
            <p>{{ item.time }} {{ item.week }}</p>
          </div>
        </div>
        <!-- 日程 -->
        <div
          v-for="(scheduleItem, itemId) in Object.values(scheduleList)"
          class="schedule-day"
          ref="schedule" 
          :style="`--td-width:${tdWidth}px;`"
          :key="itemId"
        >
          <h4 class="day-title" :id="'item'+itemId">DAY{{ itemId + 1 }}</h4>
          <!-- 开幕式 -->
          <!-- .opening -->
          <table class="schedule-item" v-if="hasopening && itemId==0">
            <div class="time-container">
              <div class="time-list opening">
                <td class="time-title"><img src="../assets/img/time.png" /></td>
                <td v-if="openingList.length==0" class="time-header">
                  9:00<br />-<br />12:00
                </td>
                <slot v-else>
                  <td class="time-header" v-for="(t, index) in openingList" :key="index">
                    {{ t.desc.split(",")[0] }}<br />-<br />{{ t.desc.split(",")[1] }}
                  </td>
                </slot>
              </div>
            </div>
            <div class="type-list">
              <div class="type-item">
                <tr class="item-container opening" :style="`--td-width-5:${tdWidth*scheduleLen}px;`">
                  <td class="schedule-title">
                    <h4>开幕式</h4>
                    <button @click="toLive(7)" 
                      v-if="openinglive && theTime>=firstTime && theTime<(firstTime+global.timestamp)" 
                    >进入直播间</button>
                  </td>
                  <!-- <div class="no-detail"> -->
                  <td v-if="openingList.length==0" class="schedule-detail no-schedule">
                    敬请期待
                  </td>
                  <!-- </div> -->
                  <slot v-else>
                    <td class="schedule-detail" v-for="(item, index) in openingList" :key="index">
                      <h4>{{ item.content_note }}</h4>
                      <div class="lecturer-list">
                        <p class="name">{{item.content.split('，')[0].split('|')[0]}}</p>
                        <p class="company"> {{item.content.split('，')[0].split('|')[1]}} <br/> {{item.content.split('，')[1]}} </p>
                      </div>
                    </td>
                  </slot>
                </tr>
              </div>
            </div>
          </table>
          <!-- 非开幕式 -->
          <table class="schedule-item">
            <div class="time-container">
              <slot v-for="(time, k) in Object.values(timeList)[itemId]">
                <div
                  v-if="!(itemId==0 && k=='am')"
                  class="time-list"
                  :key="k"
                >
                  <td class="time-title"><img src="../assets/img/time.png" /></td>
                  <td class="time-header" v-for="(t, index) in time" :key="index">
                    {{ t.split("-")[0] }}<br />-<br />{{ t.split("-")[1] }}
                  </td>
                </div>
              </slot>
            </div>
            <div class="type-list">
              <slot v-for="(daySchedule, j) in scheduleItem">
                <!-- 2023手动屏蔽groupId==6的专场 -->
                <div class="type-item" v-if="j!=6" :key="j">
                  <tr
                    v-for="(item, index) in daySchedule"
                    class="item-container"
                    :key="index"
                  >
                    <td class="schedule-title" @click="toSubject(item.id)">
                      <h4>{{ item.venueName }}</h4>
                      <p>出品人：{{ item.producers }}</p>
                      <!-- <p @click="item.producerId?toTeacher(item.producerId):''">出品人：{{ item.name }}</p> -->
                    </td>
                    <slot v-if="!(global.year=='2024' && j==6)">
                      <!-- 敬请期待 -->
                      <div class="no-detail" v-if="!item.detail || item.detail.length <= 0">
                        <td class="schedule-detail no-schedule"
                          v-for="n in item.times.split(',').length" 
                          :key="n"
                        >敬请期待</td>
                      </div>
                      <!-- 课程 -->
                      <slot v-else v-for="(schedule, i) in item.detail">
                        <td v-if="schedule=='敬请期待'" 
                          class="schedule-detail no-schedule" 
                          :key="'_'+i"
                        >敬请期待</td>
                        <td v-else
                          class="schedule-detail"
                          @click="toCourse(schedule.courseId)"
                          :data-courseid="schedule.courseId"
                          :key="i"
                        >
                          <!-- {{schedule}} -->
                          <h4>{{ schedule.courseTitle }}</h4>
                          <div
                            v-for="(lecturer, id) in schedule.lecturers"
                            class="lecturer-list"
                            :key="id"
                          >
                            <p class="name">{{ lecturer.name }}</p>
                            <p class="company">
                              {{ lecturer.company }}<br />{{ lecturer.position }}
                            </p>
                          </div>
                        </td>
                      </slot>
                    </slot>
                    <slot v-else>
                      <!-- {{ item.detail }}  -->
                      <div class="no-detail" v-if="!(extraList[itemId] && extraList[itemId][index] && extraList[itemId][index].length>0)">
                        <td class="schedule-detail no-schedule"
                          v-for="n in item.times.split(',').length" 
                          :key="n"
                        >敬请期待</td>
                      </div>
                      <slot v-else>
                        <!-- {{ itemId }} {{ index }} {{ '-' }}  -->
                        <!-- {{ extraList[itemId][index] }} -->
                        <td class="schedule-detail extra" 
                          v-for="(schedule, i) in extraList[itemId][index]"
                          :key="'extra'+i"
                        >
                          {{schedule}}
                        </td>
                      </slot>
                    </slot>
                  </tr>
                </div>
              </slot>
            </div>
          </table>
        </div>
      </section>
      <!-- mob -->
      <section class="mob-schedule">
        <!-- 导航 -->
        <div class="mob-schedule-time">
          <div
            v-for="(item, index) in dayList"
            class="mob-time-item"
            :class="item.timeStamp == selectedDate ? 'selected' : ''"
            :data-time="item.timeStamp"
            :key="index"
            @click="toggleDay(index, $event)"
          >
            <div>DAY{{ index + 1 }}</div>
          </div>
        </div>
        <!-- 日程 -->
        <!-- 增加开幕式 -->
        <div
          v-for="(typeList, i) in scheduleList"
          class="mob-schedule-list"
          :class="i === selectedDate ? 'actived' : ''"
          :key="i"
        >
          <div class="mob-type-list">
            <div 
              v-if="hasopening && selectedDate==dayList[0].timeStamp"
              class="mob-type-item"
              :class="[0 == selectedSchedule ? 'selected' : '', openinglive ? 'live' : '']"
              :data-id="0"
              @click="toggleSchedule"
            >
              开幕式
              <button @click="toLive(7)" 
                v-if="openinglive && theTime>=firstTime && theTime<(firstTime+global.timestamp)" 
              >进入直播间</button>
            </div>
            <!-- 2023手动屏蔽groupId==6的专场 -->
            <slot v-for="(type, j) in typeList">
              <div
                v-if="j!=6"
                class="mob-type-item"
                :class="j === selectedSchedule ? 'selected' : ''"
                :data-id="j"
                :key="j"
                @click="toggleSchedule"
              >
                {{ type[0] && type[0].venueName }}{{ type[1] && "/" + type[1].venueName }}
              </div>
            </slot>
          </div>
          <!-- 开幕式 -->
          <div v-if="hasopening && selectedSchedule==0" class="mob-speech-wrapper" :class="0 == selectedSchedule ? 'actived' : ''">
            <div class="mob-speech-list">
              <div class="mob-speech-item" v-if="openingList.length==0">
                <h4>敬请期待</h4>
                <p class="time">
                  <span class="glyphicon glyphicon-time"></span>
                  09:00-12:00
                </p>
              </div>
              <slot v-else>
                <div class="mob-speech-item" v-for="(o, j) in openingList" :key="j">
                  <h4>{{ o.content_note }}</h4>
                  <div 
                    class="mob-lecturer-list"
                  >
                    <p class="lecturer">
                      <span>{{ o.content.split('，')[0].split('|')[0] }}</span>
                      {{ o.content.split('，')[0].split('|')[1] }} {{ o.content.split('，')[1] }}
                    </p>
                  </div>
                  <p class="time">
                    <span class="glyphicon glyphicon-time"></span>
                    {{ o.desc.split(",")[0] }}-{{ o.desc.split(",")[1] }}
                  </p>
                </div>
              </slot>
            </div>
          </div>
          <!-- 非开幕式 -->
          <div v-for="(type, j) in typeList" class="mob-speech-wrapper" :class="j === selectedSchedule ? 'actived' : ''" :key="j">
            <div class="mob-speech-list" v-for="(s, k) in type" :key="k">
              <slot v-if="s.detail">
                <div
                  v-for="(speech, key) in s.detail"
                  class="mob-speech-item"
                  :data-courseId="speech.courseId"
                  :key="key"
                  @click="toCourse(speech.courseId)"
                >
                  <slot v-if="!speech || speech=='敬请期待'">
                    <h4>敬请期待</h4>
                    <p class="time" v-if="s.times && s.times.split(',')[key]">
                      <span class="glyphicon glyphicon-time"></span>
                      <!-- {{ speech }} {{ key }} -->
                      {{ s.times.split(',')[key] }}
                    </p>
                  </slot>
                  <slot v-else>
                    <h4>{{ speech.courseTitle }}</h4>
                    <div 
                      v-for="(lecturer, l) in speech.lecturers"
                      class="mob-lecturer-list"
                      :key="l"
                    >
                      <p class="lecturer">
                        <span>{{ lecturer.name }}</span
                        >{{ lecturer.company }} {{ lecturer.position }}
                      </p>
                    </div>
                    <p class="time">
                      <span class="glyphicon glyphicon-time"></span>
                      {{ speech.time }}
                    </p>
                  </slot>
                </div>
              </slot>
              <div v-else class="mob-speech-item">
                <h4>敬请期待</h4>
                <p class="time" v-if="s.times">
                  <span class="glyphicon glyphicon-time"></span>
                  {{ s.times.slice(0,5) }}-{{ s.times.slice(-5) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Title from "@/components/Title";
import { sid, openingid, getSpeechInfoNew, getSpeechInfoFinal, getScheduleInfo, getSue } from "@/utils/api.js";

const weekList = {
  0: "星期日",
  1: "星期一",
  2: "星期二",
  3: "星期三",
  4: "星期四",
  5: "星期五",
  6: "星期六",
};
const amTimeStr =
  "9:00-10:00,10:00-11:00,11:00-12:00,8:45-9:35,9:35-10:25,10:25-11:15,11:15-12:05";
const pmTimeStr = "13:30-14:30,14:30-15:30,15:50-16:50,16:50-17:50";
export default {
  name: "NewSchedule",
  components: {
    Title,
  },
  data() {
    return {
      title: "大会日程",
      description: "年度技术创新及研发实践的架构案例",
      selectedDate: "",
      selectedSchedule: "1", // 移动端选中的日程
      dayList: [], // 日期列表
      scheduleList: {}, // 日程列表
      timeList: {},
      totalScheduleList: [],
      schedulelive: false, // 日程是否直播
      openinglive: false, // 开幕式是否直播
      openingList: [], // 开幕式
      hasopening: false, // 日程含开幕式
      tdWidth: 186, // 日程td宽度
      theTime: new Date(2023,11,25).getTime(), // 当前时间
      firstTime: new Date(2023,11,24).getTime(), // 日程第一天
      lastTime: new Date(2023,11,25,23,59,59).getTime(), // 日程最后一天
      extraList: [[[]],[[],[]]], // 2023第5专场
    };
  },
  computed: {
    scheduleLen() { // 2023手动屏蔽第6场,固定为5
      // let len = 0;
      // if(
      //   this.dayList[0] && 
      //   this.dayList[0].timeStamp && 
      //   this.scheduleList && 
      //   this.scheduleList[this.dayList[0].timeStamp] 
      // ){
      //   len = Object.keys(this.scheduleList[this.dayList[0].timeStamp]).length
      // }
      // return len;
      return 5;
    }
  },
  mounted() {
    if(sid(this.global.year)) {
      this.getSpeech();
      this.getSchedule();
      this.getOpening();
    }
    this.setScroll();
    // this.setExtraList();
  },
  methods: {
    scrollSmoothTo(position) {
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback, element) {
          return setTimeout(callback, 17);
        };
      }
      // 当前滚动高度
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动step方法
      var step = function () {
        // 距离目标滚动距离
        var distance = position - scrollTop;
        // 目标滚动位置
        // console.log('scrollSmoothTo ', position, scrollTop, distance, document.body.offsetTop);
        scrollTop = scrollTop + distance / 5;
        if (Math.abs(distance) < 1) {
          window.scrollTo(0, position);
        } else {
          window.scrollTo(0, scrollTop);
           requestAnimationFrame(step);
        }
      };
      step();
    },
    setScroll() {
      let w_width = window.innerWidth;
      let w_height = window.innerHeight;
      window.onresize = ()=>{
        w_width = window.innerWidth;
        w_height = window.innerHeight;
      }
      $("#menu").css({ display: "none" });
      $(() => {
        $(window).scroll(() => {
          if(this.$route.path == `/${this.global.year}/schedule`){
            let s_top = document.body.scrollTop || document.getElementsByTagName('body').scrollTop || window.pageYOffset;
            let header_height = document.getElementsByClassName('pc-wrapper')[0] ? document.getElementsByClassName('pc-wrapper')[0].offsetHeight : 0;
            let top = $('.content li') && $('.content li').offset() && $('.content li').offset().top || 0;
            let item1 = this.$refs.schedule && this.$refs.schedule[0];
            let item2 = this.$refs.schedule && this.$refs.schedule[1];
            // console.log(item1, item2)
            if(item2 && item2.offsetTop){
              let h1 = item1 && item1.offsetTop ? (item1.offsetTop + top - (w_height-header_height)) : 0;
              let h2 = item2.offsetTop + top - (w_height-header_height);
              // console.log('scroll ', $(window).scrollTop(), s_top, h, this.selectedDate);
              // console.log($(window).scrollTop(), h1, h2)
              if(w_width > 750){
                if ($(window).scrollTop() > h1 && $(window).scrollTop()<=h2) {
                  $("#menu").fadeOut(500);
                  this.selectedDate = this.dayList[0].timeStamp;
                } else if ($(window).scrollTop() > h2) {
                  $("#menu").fadeIn(500);
                  this.selectedDate = this.dayList[1].timeStamp;
                }
              }
            }
          }
        });
      })
    },
    setTdWidth(len) {
      let res = 0;
      setTimeout(() => {
        let dayCon = $('.schedule-content .schedule-day');
        let timeCon = $('.schedule-content .schedule-day .schedule-item .time-container .time-list');
        let width1 = dayCon && dayCon.length>0 && dayCon.css('width')
          ? parseFloat(dayCon.css('width').split('px')[0])
          : 0;
        let width2 = timeCon && timeCon.length>0 && timeCon.css('width')
          ? parseFloat(timeCon.css('width').split('px')[0])
          : 0;
        let paddingWidth1 = dayCon && dayCon.length>0 && dayCon.css('padding-left')
          ? parseFloat(dayCon.css('padding-left').split('px')[0])
          : 0;
        let paddingWidth2 = dayCon && dayCon.length>0 && dayCon.css('padding-right')
          ? parseFloat(dayCon.css('padding-right').split('px')[0])
          : 0;
        res = (width1-width2-paddingWidth1-paddingWidth2)/len;
        this.tdWidth = res;
        // console.log( len, dayCon, timeCon, res );
        window.addEventListener('resize', ()=>{
          let dayCon = $('.schedule-content .schedule-day');
          let timeCon = $('.schedule-content .schedule-day .schedule-item .time-container .time-list');
          let width1 = dayCon && dayCon.length>0 && dayCon.css('width')
            ? parseFloat(dayCon.css('width').split('px')[0])
            : 0;
          let width2 = timeCon && timeCon.length>0 && timeCon.css('width')
            ? parseFloat(timeCon.css('width').split('px')[0])
            : 0;
          res = (width1-width2)/len;
          this.tdWidth = res;
          // console.log( len, dayCon, timeCon, res );
        })
      }, 100);
      return res;
    },
    toggleDay(index, e) {
      this.selectedDate = e.currentTarget.dataset.time;
      this.selectedSchedule = this.hasopening&&this.selectedDate==this.dayList[0].timeStamp ? "0" : "1";
      // window.scrollTo(0, this.$refs.schedule[index].offsetTop - 121);
      this.scrollSmoothTo(this.$refs.schedule[index].offsetTop-150);
    },
    toggleSchedule(e) {
      this.selectedSchedule = e.target.dataset.id;
    },
    toCourse(e) {
      this.$router.push({
        path: "/2024/course",
        name: "FourCourse",
        // query: { id: e.target.dataset.courseid },
        query: { id:e }
      });
    },
    toTeacher(e) {
      this.$router.push({
        path:"/2024/teacher",
        name:"FourTeacher",
        query:{ id:e }
      });
    },
    toSubject(e) {
      this.$router.push({
        path:"/2024/subject",
        name:"FourSubject",
        query:{ id:e }
      });
    },
    toLive(id) {
      this.$router.push({path:'/2024/live', query:{groupid:7, time:parseInt(this.firstTime/1000)}});
    },
    filterSpeechList(speechList) {
      const totalList = [];
      //   根据日期对日程进行分类
      for (const [key, value] of Object.entries(speechList)) {
        // console.log(key);
        // console.log(value);
        const { am: amList, pm: pmList } = value;
        // 遍历整合上午的日程
        for (const [type, val] of Object.entries(amList)) {
          // console.log(type);
          // console.log(val);
          for (const [k, v] of Object.entries(val)) {
            // console.log(k);
            // console.log(v);
            const timeStr = val.time[0] + "-" + val.time[1];
            if (k !== "time" && !Array.isArray(v)) {
              // 每个日程详情内添加会议时间和groupId
              v.timeStamp = key;
              v.time = timeStr;
              v.type = k;
              v.addType = "am";
              totalList.push(v);
            } else {
              // 添加上午的时间列表
              if (this.timeList[key] === undefined) {
                this.timeList[key] = { am: [], pm: [] };
              }
              if (
                this.timeList[key].am.indexOf(timeStr) <= -1 &&
                this.timeList[key].am.length < 3
              ) {
                this.timeList[key].am.push(timeStr);
              }
            }
          }
        }
        // 遍历整合下午的日程
        for (const [type, val] of Object.entries(pmList)) {
          // console.log(type, val);
          for (const [k, v] of Object.entries(val)) {
            // console.log(k);
            // console.log(v);
            const timeStr = val.time[0] + "-" + val.time[1];
            if (k !== "time" && !Array.isArray(v)) {
              v.timeStamp = key;
              v.time = timeStr;
              v.type = k;
              v.addType = "pm";
              totalList.push(v);
            } else {
              if (this.timeList[key] === undefined) {
                this.timeList[key] = { am: [], pm: [] };
              }
              if (this.timeList[key].pm.indexOf(timeStr) <= -1) {
                this.timeList[key].pm.push(timeStr);
              }
            }
          }
        }
        this.totalScheduleList = totalList;
        // console.log("totalScheduleList ", this.totalScheduleList);
        // console.log("this.scheduleList ", this.scheduleList);
        // console.log("this.dayList ", this.dayList);
        let times_arr = [];
        let times_data = [];
        for (const [key, value] of Object.entries(this.scheduleList)) {
          for (let k in value) {
            // console.log(value[k]);
            // "am"
            if (value[k][0]) {
              // 设置敬请期待
              // value[k][0].noDetail = [{}, {}, {}];
              // 敬请期待 + 日程
              value[k][0].detail = []
              times_arr = value[k][0].times.split(",");
              // console.log(times_arr);
              for(let t in times_arr){
                value[k][0].detail.push('敬请期待');

                times_data = this.totalScheduleList.filter(
                  (item) =>
                    item.timeStamp === key &&
                    item.type === k &&
                    item.addType === "am" && 
                    item.time == times_arr[t]
                )
                times_data.length>0 ? value[k][0].detail[t]=times_data[0] : '';

              }
              // console.log('am-detail---', value[k][0].detail)
              // 设置日程详情
              // value[k][0].detail = this.totalScheduleList.filter(
              //   (item) =>
              //     item.timeStamp === key &&
              //     item.type === k &&
              //     item.addType === "am"
              // );
            }
            // "pm"
            let pmIndex = 1;
            if(this.hasopening && this.dayList[0].timeStamp==key){
              pmIndex = 0;
            }
            if (value[k][pmIndex]) {
              // 设置敬请期待
              // value[k][pmIndex].noDetail = [{}, {}, {}, {}];
              // 敬请期待 + 日程
              value[k][pmIndex].detail = []
              times_arr = value[k][pmIndex].times.split(",");
              // console.log(times_arr);
              for(let t in times_arr){
                value[k][pmIndex].detail.push('敬请期待');
                times_data = this.totalScheduleList.filter(
                  (item) =>
                    item.timeStamp === key &&
                    item.type === k &&
                    item.addType === "pm" && 
                    item.time == times_arr[t]
                )
                times_data.length>0 ? value[k][pmIndex].detail[t]=times_data[0] : '';
              }
              // console.log(value[k][pmIndex].detail)
              // 设置日程详情
              // value[k][pmIndex].detail = this.totalScheduleList.filter(
              //   (item) =>
              //     item.timeStamp === key &&
              //     item.type === k &&
              //     item.addType === "pm"
              // );
            }
          }
        }

        // console.log("scheduleList ", this.scheduleList);
        // console.log(this.timeList);
      }
    },
    filterAllSchedule(list) {
      const obj = {};
      list.map((item) => {
        // console.log(this.hasopening, item);
        if(
          !this.hasopening || 
          (this.hasopening && item.venueName.indexOf('开幕式')==-1)
        ){
          if (obj[item.date]) {
            if (obj[item.date][item.groupId]) {
              obj[item.date][item.groupId].push(item);
            } else {
              obj[item.date][item.groupId] = [item];
            }
          } else {
            obj[item.date] = {};
            obj[item.date][item.groupId] = [item];
          }
          // 添加 am/pm
          if (amTimeStr === item.times) {
            item.addType = "am";
          } else if (pmTimeStr === item.times) {
            item.addType = "pm";
          }
        }
      });
      // console.log(list,obj);
      return obj;
    },
    getSpeech() {
      // var url = "https://api.msup.com.cn/group/get-group-project/2682";
      // let url = getSpeechInfoNew + sid(this.global.year);
      let url = getSpeechInfoFinal + sid(this.global.year);
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json();
        })
        .then((res) => {
          if (res.errno == 0) {
            // console.log("getSpeech data: ", res.data);
            this.hasopening = false;
            if(res.data[0].venueName.indexOf('开幕式') != -1){
              this.hasopening = true;
              this.selectedSchedule = "0";
            }
            this.scheduleList = this.filterAllSchedule(res.data);
            // console.log(res.data, this.scheduleList);
          }
        });
    },
    getSchedule() {
      // var url = "https://api.msup.com.cn/scheduling/get-schedule/2682";
      let url = getScheduleInfo + sid(this.global.year);
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json();
        })
        .then((res) => {
          if (res.errno == 0) {
            // console.log("schedule ", res.data);
            this.dayList = [];
            if(res.data && res.data.finishing){
              for(let item of Object.keys(res.data.finishing)){
                this.dayList.push({
                  timeStamp: item,
                  time: dayjs(item * 1000).format("YYYY.MM.DD"),
                  week: weekList[new Date(item * 1000).getDay()],
                });
              }
            }
            this.selectedDate = this.dayList[0] && this.dayList[0].timeStamp || '';
            this.totalScheduleList = this.filterSpeechList(res.data.datas);
            this.getLive();
          }
        });
    },
    getOpening() {
      let url = `${getSue}${openingid(this.global.year)}`;
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          // console.log("opening ", data);
          if(data.errno == 0){
            this.openingList = data.data[0];
          }
        })
    },
    getLive() {
      // 直播
      let url = `${getSue}304`;
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          // console.log("live ", data);
          if(data.errno==0 && data.data && data.data[0]){
            for(let item of data.data[0]){
              if(item.title == sid(this.global.year)){
                // console.log(item, this.dayList);
                if(item.detailType && item.detailType!=237){
                  // 237 NO   234 EXCEPT OPENING   233 ONLY OPENING   232 YES
                  if(item.detailType == 232){
                    this.schedulelive = true;
                    this.openinglive = true;
                  }
                  if(item.detailType == 233){
                    this.schedulelive = false;
                    this.openinglive = true;
                  }
                  if(item.detailType == 234){
                    this.schedulelive = true;
                    this.openinglive = false;
                  }
                  this.theTime = new Date().getTime();
                  this.firstTime = this.dayList[0].timeStamp*1000;
                  this.lastTime = this.dayList.slice(-1)[0].timeStamp*1000;
                }
              }
            }
          }
        })
    },
    setExtraList() {
      let url = `${getSue}353`;
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          // console.log("extraList ", data);
          let day=1, group=['am','pm'], index=0, time='09:00';
          if(data.errno=='0' && data.data && data.data[0]){
            for(let item of data.data[0]){
              day = parseInt(item.desc.split('-')[0]) - 1;
              index = day==0 ? 0 : group.indexOf(item.desc.split('-')[1]);
              this.extraList[day][index].push({
                title: item.content_note,
                startTime: item.desc.split(',')[2],
                endTime: item.desc.split(',')[3],
                name: item.content.split('-')[0],
                position: item.content.split('-')[1],
              });
            }
            for(let d in this.extraList){
              for(let i in this.extraList[d]){
                this.extraList[d][i].sort(this.global.toSortKey('startTime',1,'string'));
              }
            }
          }
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule .no-schedule {
  width: 100%;
  // line-height: 75px;
  // font-family: PingFangSCBold;
  // font-weight: 500;
  // font-size: 16px;
  // text-align: center;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 90px;
  padding-bottom: 40px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: var(--main-color-text);
  border-bottom: 1px solid transparent;
}
@media (max-width: 767px) {
  .schedule-content {
    display: none;
  }
  .mob-schedule {
    display: block;
  }
}
@media (min-width: 768px) {
  .schedule-content {
    display: block;
  }
  .mob-schedule {
    display: none;
  }
}
@media (max-width: 750px) {
  .schedule .no-schedule {
    padding-top: 60px;
    font-size: 16px;
  }
}

#menu {
  position: fixed;
  bottom: 50px;
  right: 20px;
  display: none;
  ul li a {
    display: block;
    border: 1px solid #0088bb;
    margin: 5px 0;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    width: 80px;
    height: 50px;
    line-height: 50px;
    text-decoration: none;
    text-align: center;
    transition: background-color .25s linear;
    &:hover,
    &.current {
      border: 1px solid #48A3D8;
      color: #fff;
      background: #48A3D8;
    }
  }
}
@media (max-width: 767px) {
  #menu {
    display: none!important;
  }
}

// pc端样式
.schedule-content {
  padding-top: 45px;
  padding-bottom: 30px;
  .schedule-time {
    display: flex;
    justify-content: center;
    .time-item {
      margin-left: 60px;
      margin-right: 60px;
      padding-left: 50px;
      padding-right: 50px;
      width: 232px;
      height: 100px;
      color: #000;
      // border: 1px solid #0b70a4;
      border: 1px solid #48a3d8;
      cursor: pointer;
      transition: all 0.3s;
      h4 {
        margin-bottom: 0;
        padding-top: 20px;
        // padding-top: 25px;
        font-size: 36px;
        font-weight: 500;
        color: inherit;
        text-align: center;
      }
      p {
        margin-bottom: 0;
        font-size: 15px;
        font-weight: 500;
        color: inherit;
        white-space: pre;
      }
      &.selected {
        color: #fff;
        background: var(--main-color-user);
        p {
          font-weight: 600;
        }
      }
    }
  }
  .schedule-day {
    margin-left: auto;
    margin-right: auto;
    padding: 0 20px;
    max-width: 1240px;
    .day-title {
      margin-top: 20px;
      margin-bottom: 20px;
      font-weight: 600;
      font-size: 40px;
      text-align: center;
      padding-top: 45px;
      padding-bottom: 35px;
    }
    .schedule-item {
      display: flex;
      .time-container {
        border-left: 1px solid #ddd;
        img {
          height: 94px;
        }
      }
      td {
        border: 1px solid #ddd;
        border-left: none;
        border-top: none;
      }
      .time-container .time-list:nth-of-type(1), 
      .type-list .type-item tr:nth-of-type(1) {
        td:nth-of-type(1) {
          border-top: 1px solid #ddd;
        }
      }
      .time-container {
        display: flex;
        flex-direction: column;
        .time-list {
          display: flex;
          flex-direction: column;
          .time-title {
            padding-right: 42px;
          }
          .time-header {
            height: 280px;
            font-size: 16px;
            background: #fafbfc;
            color: #000;
            text-align: center;
            line-height: 24px;
            padding-left: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }
      }
      .type-list {
        display: flex;
        .type-item {
          display: flex;
          flex-direction: column;
          .item-container {
            display: flex;
            flex-direction: column;
            &:first-child {
              height: 936px;
            }
            &:last-child {
              height: 1216px;
            }
            .schedule-title {
              width: var(--td-width);
              height: 96px;
              text-align: left;
              color: #000;
              display: flex;
              flex-direction: column;
              // justify-content: center;
              justify-content: space-around;
              padding-top: 10px;
              padding-left: 14px;
              cursor: pointer;
              h4 {
                height: inherit;
                font-size: 18px;
                font-weight: 700;
              }
              p {
                // margin-top: 8px;
                margin-top: 0;
                margin-bottom: 10px;
                font-size: 14px;
                cursor: pointer;
                font-weight: 600;
              }
            }
            &.opening .schedule-title {
              flex-direction: initial;
              justify-content: center;
              align-items: center;
              button {
                height: auto;
                line-height: 1;
                font-size: 16px;
                font-weight: 500;
                padding: 10px 20px;
                margin-left: 30px;
                border: none;
                border-radius: 18px;
                // color: #ffffff;
                color: #eeeeee;
                background: var(--main-color-user);
              }
            }
            .schedule-detail {
              flex-grow: 1;
              width: var(--td-width);
              max-height: 280px;
              background: #fafbfc;
              text-align: center;
              font-size: 14px;
              color: #333;
              cursor: pointer;
              display: flex;
              flex-direction: column;
              justify-content: center;
              h4 {
                width: 100%;
                height: 66px;
                color: #1f63af;
                font-size: 16px;
                font-weight: 400;
                line-height: 22px;
                text-align: center;
                padding: 0 10px;
                margin-bottom: 5px;
                // 省略
                word-break: break-all;
                word-wrap: break-word;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              .lecturer-list {
                p {
                  text-align: center;
                }
                .name {
                  font-size: 14px;
                  color: #333;
                  font-weight: 700;
                  // margin-top: 10px;
                  margin-bottom: 0;
                }
                .company {
                  height: 65px;
                  font-size: 14px;
                  color: #666;
                  padding-top: 5px;
                  padding-left: 5px;
                }
              }
            }
            .no-detail {
              background: #fafbfc;
              flex-grow: 1;
              display: flex;
              flex-direction: column;
              .no-schedule {
                flex-grow: 1;
                // font-size: 16px;
                font-size: 14px;
                border-top: none;
              }
            }
          }
        }
      }
      div .opening {
        height: 100%!important;
        &.item-container {
          td {
            width: var(--td-width-5)!important;
          }
        }
        td {
          &.time-header, &.schedule-detail {
            // height: auto!important;
            height: 150px!important;
            padding: 10px 0;
            &:nth-last-of-type(1){
              border-bottom: 0;
            }
          }
          &.schedule-detail{
            h4 {
              height: auto!important;
            }
            p.company {
              height: auto!important;
              margin-bottom: 0;
            }
          }
          &.schedule-title {
            padding: 0!important;
            h4 {
              height: max-content!important;
              margin-bottom: 0;
            }
          }
          h4 {
            text-align: center;
          }
        }
      }
    }
  }
}

// 移动端样式
.mob-schedule {
  padding-top: 30px;
  .mob-schedule-time {
    display: flex;
    justify-content: center;
    .mob-time-item {
      border: 1px solid var(--main-color-user);
      min-width: 135px;
      height: 60px;
      line-height: 60px;
      &.selected {
        color: #fff;
        background: var(--main-color-user);
      }
      div {
        font-size: 30px;
        font-weight: 500;
        text-align: center;
      }
    }
  }
  .mob-schedule-list {
    display: none;
    &.actived {
      display: block;
    }
    .mob-type-list {
      padding: 30px 3vw;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .mob-type-item {
        margin-bottom: 6px;
        background: rgb(249, 249, 249);
        color: #2c3e50;
        width: 46vw;
        height: 60px;
        line-height: 60px;
        padding-left: 4vw;
        padding-right: 4vw;
        font-size: 15px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        &.selected {
          background: rgb(224, 224, 224);
        }
        &.live {
          width: 94vw;
          height: fit-content;
          line-height: 30px;
          padding: 15px 4vw;
          padding-left: 16vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          button {
            height: fit-content;
            line-height: 28px;
            border: 1px solid #aaaaaa;
            border-radius: 5px;
            padding: 0 15px;
          }
        }
      }
    }
  }
  .mob-speech-wrapper {
    display: none;
    &.actived {
      display: block;
    }
    .mob-speech-item {
      margin: 0 auto;
      background: #f9f9f9;
      color: rgb(0, 0, 0);
      width: 94vw;
      padding: 20px;
      margin-bottom: 10px;
      text-align: left;
      h4 {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 10px;
      }
      .mob-lecturer-list {
        .lecturer {
          margin-bottom: 5px;
          font-size: 14px;
          span {
            font-weight: 500;
            margin-right: 5px;
          }
        }
      }
      .time {
        font-size: 14px;
      }
    }
  }
}
</style>